import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import T from 'i18n-react';
import Theme from './Theme';

import Main from "./components/Main";
import Start from "./Start";
import { AccountsModel, RequestAjaxClass } from 'models-lib';
import { MessageBox, ConfirmBox } from 'component-lib'; 
import { ClosePopUps } from 'utils-lib';
import GlobalConfig from './globalConfig.json';

var language = localStorage.getItem('vas_language') !== null ? localStorage.getItem('vas_language') : 'de';
if (localStorage.getItem('vas_language') === null)
    {localStorage.setItem('vas_language','de');}
//var language = 'de';
//var data = require('./i18n/'+ language +'.json');

var data = require('./projects/' + GlobalConfig.Project + '/i18n/'+ language +'.json');

T.setTexts(data);
var Config = require('./projects/'+ GlobalConfig.Project + '/config.json');

class Vas extends Component
{
    static CopyrightMail = Config.Copyright.CopyrightMail;
    static CopyrightPhone = Config.Copyright.CopyrightPhone;
    static ApplicationUrl = "http://localhost:3000";
    static Theme = new Theme();
    //static ApiUrl = Config.Configurations.ApiUrl;
    static ApiUrl = "http://abo-online.sts.local:8081/api";         //Lokale API             
    //static ApiUrl = "https://www.cvag.de/api-abo-online/api/";    //CVAG-Prod API
    static ApiKey = "5567GGH8635B!83GhT!j75%";
    static Debug = "false";
    static Resources = T.texts;
    static MessageBox;
    static Content = null;
    static Slider = null;
    static MaxDayContractCreation = "21";
    static Captcha = true;
    static TimeOutTime = 1000;
    static AccountsModel = new AccountsModel([this]);
    static Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);

    static CsvDownloadContracts = Config.CsvDownload.Contracts;
    static CsvDownloadCustomers = Config.CsvDownload.Customers;

    static Config = Config;

    static isIE = /*@cc_on!@*/false || !!document.documentMode;

    static UseMMTextsForTermsOfUsage = false;

    static ClosePopUps(){
        if (document.getElementById('popupContainer')){
            if (document.getElementById('popupContainer').children.length === 0){
                ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
            } else {
                ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
            }
        
           
        } else {
            if (document.getElementById('messageContainer')){
                if (document.getElementById('messageContainer').children.length === 0){
                    ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
                } else {
                    ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
                }
            }
            
        }
    }

    static GetView(view, params, authorization, menue){


        var kontrastNumber = localStorage.getItem('Kontrast');

        if(kontrastNumber == null){
            localStorage.setItem('Kontrast', 'false');
        }

        var schriftgröße = localStorage.getItem('Schriftgröße');

        if(schriftgröße == null){
            localStorage.setItem('Schriftgröße', '0');
        }

        let flagManue = menue !== null &&menue !== undefined ? menue : false;
        Vas.ClosePopUps();
        
        clearTimeout(Vas.Slider);
        if (authorization)
        {
            switch (view)
            {
                
                case "Account":
                    if(flagManue === false){
                        localStorage.setItem("vas_selectedTab","UsernameDataLink");
                    window.location = "/account";
                    }else{
                        return "/account";
                    }

                    
                    break;
                case "Contract":
                    window.location = "/contractcard/" + params.Id+ "/"+params.CustomerId+"/"+params.CustomerName;
                    //Vas.Content.setState({content: <ContractCard Id={params.Id} CustomerId={params.CustomerId} CustomerName={params.CustomerName}/>});
                    break;    
                case "Contracts":
                    if(flagManue === false){
                        localStorage.setItem("vas_selectedTab","ContractDataLink");
                        window.location = "/contracts/" +params.All;
                    }else{
                        return "/contracts/" +params.All;
                    }
                    
                    break;
                case "CustomerCard":
                    if(flagManue === false){
                        localStorage.setItem("vas_selectedTab","PersonalDataLink");
                        window.location = "/customercard/"+params.Id;
                    }else{
                        return "/customercard/"+params.Id;
                    }
                   
                    break;
                case "ChangePassword":
                    window.location = "/changePassword";
                    break;
                case "ChangePasswordSuccess":
                    window.location = "/ChangePasswordSuccess";
                    break;
                case "Order":
                    if(flagManue === false){
                        localStorage.setItem("vas_selectedTab","NewContractDataLink");
                        window.location = "/orderContract/" + params.CustomerId + "/" + params.ContractId;
                    }else{
                        return "/orderContract/" + params.CustomerId + "/" + params.ContractId;
                    }
                    
                    break;
                case "OrderSuccess":
                    window.location = "/orderSuccess";
                    break;    
                case "Payment":
                    localStorage.setItem("vas_selectedTab","PaymentDataLink");
                    window.location = "/customerPayment";
                    break;                
                case "DocumentOverView":
                    localStorage.setItem("vas_selectedTab","DocumentDataLink");
                    window.location = "/documentOverView";
                    break;

                case "VerificationOverView":
                    localStorage.setItem("vas_selectedTab","VerificationDataLink");
                    window.location = "/verificationOverView";
                    break;

                case "AdditionalAddresses":
                    localStorage.setItem("vas_selectedTab","AdditionalAddressesDataLink");
                    break;
                
                case "NoPayment":
                    window.location = "/noPayment/" + params.CustomerId + "/" + params.NewContract;
                    break;
                case "CreatePayment":
                    window.location = "/createPayment/" + params.CustomerId + "/" + params.NewContract + "/" + params.PaymentId;
                    break;
                case "CreatePaymentSuccess":
                    window.location = "/createPaymentSuccess/" + params.CustomerId;
                    break;
                case "ErrorOnline":
                    window.location = "/errorOnline";
                    break;
                case "CustomerDocumentUpload":
                    window.location = "/documentUpload/" + params.CustomerId;
                    break;
                case "CustomerDocumentUploadSuccess":
                    window.location = "/documentUploadSuccess/" + params.CustomerId;
                    break;
                case "CustomerVerificationUpload":
                    window.location = "/verificationUpload/" + params.CustomerId;
                    break;
                case "CustomerVerifictaionUploadSuccess":
                    window.location = "/verificationUploadSuccess/" + params.CustomerId;
                    break;
                case "ContractCancel":
                    window.location = "/contractCancel";
                    break;
                case "ContractCancelSuccessContractCard":
                    window.location = "/contractCancelSuccess/" + params.CustomerId + "/" + params.ContractId + "/" + params.CustomerName;
                    break;
                case "Customers":
                    if(flagManue === false){
                        localStorage.setItem("vas_selectedTab","CustomersDataLink");
                        window.location = "/customers";
                    }else{
                        return "/customers";
                    }

                    
                    break;
                case "CreateCustomer":
                    window.location = "/createCustomer";
                    break;
                case "CreateCustomerSuccess":
                    window.location = "/createCustomerSuccess";
                    break;
                case "ContractEditState":
                    window.location = "/contractEditState/" + params.CustomerId + "/" + params.ContractId + "/" + params.CustomerName;
                    break;
                case "ContractEditStateSuccess":
                    window.location = "/contractEditStateSuccess/" + params.CustomerId + "/" + params.ContractId + "/" + params.CustomerName;
                    break;
                case "CreateAdditionalAddress":
                    window.location = "/createAdditionalAddress/" + params.CustomerId;
                    break;
                case "CreateAdditionalAddressSuccess":
                    window.location = "/createAdditionalAddressSuccess/" + params.CustomerId;
                    break;
                case "ChangePaymentSuccess":
                    window.location = "/changePaymentSuccess/" + params.CustomerId;
                    break;
                case "CustomerRelationDeleteSuccess":
                    window.location = "/customerRelationDeleteSuccess/" + params.CustomerId;
                    break;
                case "Home":
                    if(flagManue === false){
                        window.location = "/home";
                    }else{
                        return "/home";
                    }
                    
                    break;
                case "ChangeMail":
                    window.location = "/changeEmail/" + params.CustomerId + "/" + params.Email;
                    break;
                case "ChangeMailSuccess":
                    window.location = "/changeEmailSuccess/" + params.CustomerId;
                    break;
                case "ActivateEMailSuccess":
                    window.location = "/activateEMailSuccess";
                    break;
                case "ActivateEMailSuccessOffline":
                    window.location = "/activateEMailSuccessOffline";
                    break;
                default  :
                    ReactDOM.unmountComponentAtNode(document.getElementById('root'));
                    ReactDOM.render(( <Main />
                    ), document.getElementById('root'));
            }
        }
        else
        {
            switch (view)
            {
                case "Home":
                    localStorage.setItem("vas_selectedTab","HomeDataLink");
                    if(flagManue === false){
                        window.location = "/home";
                    }else{
                        return "/home";
                    }
                    
                    break;
                case "Impressum":
                    if(flagManue === false){
                        localStorage.setItem("vas_selectedTab","ImpressumDataLink");
                    let fenster = window.open('https://www.cvag.de/de/Impressum_1008.html','_blank');
                    fenster.focus();
                    }else{
                        return 'https://www.cvag.de/de/Impressum_1008.html';
                    }
                    
                    break;
                case "Login":
                    
                    localStorage.setItem("vas_selectedTab","LoginDataLink");
                    if(flagManue === false){
                        window.location = "/login";
                    }else{
                        return "/login"
                    }
                    break;
                case "Register":
                    
                    localStorage.setItem("vas_selectedTab","RegisterDataLink");
                    if(flagManue === false){
                        window.location = "/register";
                    }else{
                        return "/register";
                    }
                    break;
                case "RegisterQuestion":
                    
                    localStorage.setItem("vas_selectedTab","RegisterDataLink");
                    if(flagManue === false){
                        window.location = "/registerQuestion";
                    }else{
                        return "/registerQuestion";
                    }
                    break;
                case "RegisterExistingCustomer":
                    
                    localStorage.setItem("vas_selectedTab","RegisterDataLink");
                    if(flagManue === false){
                        window.location = "/registerExistingCustomer";
                    }else{
                        return "/registerExistingCustomer";
                    }
                    break;
                case "Order":
                    window.location = "/order";
                    break;
                case "Controls":
                    window.location = "/controls";
                    break;
                case "Tariffing":

                    if(params != null){
                        if(!params.BackButton){
                            localStorage.setItem('SelectedProductName', params.TicketName);
                        } else {
                            localStorage.removeItem("SelectedProductName");
                        }
                    } else {
                        localStorage.removeItem("SelectedProductName");
                        localStorage.removeItem("TermsOfUsage");
                    }

                    
                    localStorage.setItem("vas_selectedTab","TariffingDataLink");
                    if(flagManue === false){
                        window.location = "/tariffing";
                    }else{
                        return "/tariffing";
                    }
                    break;
                case "TermsOfUsage":
                    
                    localStorage.setItem("vas_selectedTab","TermsOfUsageDataLink");
                    if(flagManue === false){
                        window.location = "/termsofusage";
                    }else{
                        return "/termsofusage";
                    }
                    break;
                case "OrderSuccess":
                    window.location = "/orderSuccess";
                    break;
                case "ResetPassword":
                    window.location = "/resetPassword";
                    break;
                case "ResetPassworsSuccess":
                    window.location = "/resetPasswordSuccess";
                    break;
                case "ActivateSuccess":
                    window.location = "/activateSuccess";
                    break;
                 case "Webshop":
                    localStorage.setItem("vas_selectedTab","WebshopDataLink");
                    let fensterWebShop = window.open('https://abrm.systemtechnik-online.de/Shop/ProductSearch','_blank');
                    fensterWebShop.focus();
                    //window.location = window.location;
                    break;
                 case "Reservation":
                    localStorage.setItem("vas_selectedTab","ReservationDataLink");
                    let fensterReservation = window.open('https://abrm.systemtechnik-online.de/Shop/Reservation/SearchConnection','_blank');
                    fensterReservation.focus();
                    //window.location = window.location;
                    break;
                case "DataProtection":
                    if(flagManue === false){
                        let fensterDataProtection = window.open(Vas.ApplicationUrl+"/20_10_16_Hinweise_zur_Datenverarbeitung_und_zum_Datenschutz.pdf");
                        fensterDataProtection.focus();
                    }else{
                        return Vas.ApplicationUrl+"/20_10_16_Hinweise_zur_Datenverarbeitung_und_zum_Datenschutz.pdf";
                    }
                    
                    break;
                case "TariffData":
                    if(flagManue === false){
                        let fensterTariffData = window.open(this.Config.DataProtection.LinkTarifBestimmungen,'_blank');
                        fensterTariffData.focus();
                    }else{
                        return this.Config.DataProtection.LinkTarifBestimmungen;
                    }
                    
                    break;
                case "RegisterSuccess":
                    window.location = "/registerSuccess";
                    break;
                case "OrderNewCustomer":
                    window.location = "/orderNewCustomer" ;
                    break;
                case "OrderCustomer":
                    window.location = "/orderCustomer";
                    break;
                case "NoPaymentOffline":
                    window.location = "/noPaymentOffline";
                    break;
                case "FAQ":
                    if(flagManue === false){
                        localStorage.setItem("vas_selectedTab","FaqDataLink");
                        let fensterFaq = window.open(Vas.ApplicationUrl+"/FAQ.pdf",'_blank');
                        fensterFaq.focus();
                    }else{
                        return Vas.ApplicationUrl+"/FAQ.pdf";
                    }
                    
                    break;
                case "ErrorOffline":
                    window.location = "/errorOffline";
                    break;
                case "ErrorLogin":
                    window.location = "/error";
                    break;
                case "LogoutSuccess":
                    window.location = "/logoutSuccess";
                    break;
                case "ActivateEMailSuccessOffline":
                    window.location = "/activateEMailSuccessOffline";
                    break;
                case "VerificationReupload":
                    window.location = "/verificationReupload";
                    break;
                default:
                    ReactDOM.unmountComponentAtNode(document.getElementById('root'));
                    ReactDOM.render(( <Start />
                    ), document.getElementById('root'));
            }
        }
    }

    static FormParamsToJsonObjectByForm(id)
    {
        let result= {};
        // eslint-disable-next-line
        $("#"+id).serializeArray().map(function(item) {
            if ( result[item.name] )
            {
                if ( typeof(result[item.name]) === "string" )
                {
                    result[item.name] = [item.name];
                }
                result[item.name].push(item.value);
            }
            else
            {
                result[item.name] = item.value;
            }
        });
        return result;
    }

    static Update(observer){
        if(observer === "Logout"){
            Vas.GetView("LogoutSuccess",null,false);
        }
    }    

    static Signout()
    {
        //Vas.clearLocalStorage();
        Vas.Request.setApiKey(Vas.ApiKey);
        Vas.Request.setApiUrl(Vas.ApiUrl);
        Vas.Request.setErrorHandler(()=>{
            window.location = Vas.ApplicationUrl;
            Vas.clearLocalStorage();
            
        })
        Vas.AccountsModel.SetRequest(Vas.Request);
        Vas.AccountsModel.Logout();
                
    }

    static clearLocalStorage(excaptTariff){
        localStorage.removeItem("DayOfBirth");
        Vas.AccountsModel.clearLocalStorage(excaptTariff);
    }

    static ErrorHandling(error){
        $("#root").css("display", "block");
        $("#progressContainer").css("display", "none");
        if(error !== undefined && error !== null){
            if(error.status !== undefined && error.status !== null){
                if (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 500)
                {   

                    //Bei neuem Nachweisupload (ContractsWithConfirmations) nicht mehr relevant
                    // if(localStorage.getItem("ExecutingForm") === "OrderPopUp" 
                    //     || localStorage.getItem("ExecutingForm") === "OrderContract"){
                    //     //Biem Upload der Dokumente innerhalb der Vertragsanlage ist ein Fehler Aufgetreten
                    //     //Weiterleitung zu einer neuen Seite, die den Dokumentenupload noch einmal ermöglicht

                    //     Vas.GetView("VerificationReupload",null, false); 
                    // }
                    // else {
                        switch (error.status){
                            case 401:{

                                // expired token
                                // Beachten, wenn Kunde eingeloggt ist!
                                //Bei Expired Token ist der responseText nicht gefüllt, darum hier auf statusText 'Expired Token' prüfen
                                if (error.statusText === 'Expired Token'){

                                    //Nur, wenn der Kunde eingeloggt ist
                                    if (localStorage.getItem('vas_token')){
                                        Vas.clearLocalStorage();
                                        
                                        //Hier Hinweis auf Token Expired in LoalStorage schreiben.
                                        //Wenn Hinweis auf Token Expired in LoalStorage vorhanden, dann Hinweis entfernen und Messagebox anzeigen
                                        //localStorage.setItem("ExpiredToken", "expiredToken");

                                        Vas.GetView("ErrorLogin",null, false);                  
                                    } else {
                                        Vas.clearLocalStorage();
                                        Vas.GetView("ErrorOffline",null,false);
                                    }
                                }
                                if (error.responseText){

                                    if(error.responseText.indexOf("wrong\ncredentials") > -1){

                                        Vas.clearLocalStorage();

                                        ReactDOM.render(<MessageBox 
                                            AppURL={Vas.ApplicationUrl} 
                                            Title={Vas.Resources.Titles["Error"]} 
                                            Message={Vas.Resources.ErrorMessages["LoginFailedError"]} /> 
                                            , document.getElementById('messageContainer'));
                                    } else {

                                        let err = JSON.parse(error.responseText);

                                        if (Number(err.ErrorCode,10) !== 3){
                                            Vas.clearLocalStorage();
                                            
                                            //Hier Hinweis auf Token Expired in LoalStorage schreiben.
                                            //Wenn Hinweis auf Token Expired in LoalStorage vorhanden, dann Hinweis entfernen und Messagebox anzeigen
                                            //localStorage.setItem("ExpiredToken", "expiredToken");

                                            Vas.GetView("ErrorLogin",null, false);
                                        } else {//Login oder PW falsch
                                            if (document.getElementById('LoadingIconPopUp') === null){
                                                ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
                                            }
                                            else {
                                                $("#LoadingIconPopUp").removeClass().addClass('hide');
                                            }
                                            Vas.clearLocalStorage();

                                            ReactDOM.render(<MessageBox 
                                                AppURL={Vas.ApplicationUrl} 
                                                Title={Vas.Resources.Titles["Error"]} 
                                                Message={err.Description} /> 
                                                , document.getElementById('messageContainer'));
                                        }
                                    }
                                }
                                if(error.responseJSON){
                                    if(error.responseJSON.ErrorCode){
                                        if(error.responseJSON.ErrorCode === "2"){
                                            //Nur, wenn der Kunde eingeloggt ist
                                            if (localStorage.getItem('vas_token')){
                                                Vas.clearLocalStorage();
                                                
                                                //Hier Hinweis auf Token Expired in LoalStorage schreiben.
                                                //Wenn Hinweis auf Token Expired in LoalStorage vorhanden, dann Hinweis entfernen und Messagebox anzeigen
                                                //localStorage.setItem("ExpiredToken", "expiredToken");

                                                Vas.GetView("ErrorLogin",null, false);                  
                                            } else {
                                                Vas.clearLocalStorage();
                                                Vas.GetView("ErrorOffline",null,false);
                                            }
                                        }
                                    }
                                }

                                // Vas.clearLocalStorage();

                                // ReactDOM.render(<MessageBox 
                                //     AppURL={Vas.ApplicationUrl} 
                                //     Title={Vas.Resources.Titles["Error"]} 
                                //     Message={"Die Logindaten sind ungültig."} 
                                //     Click={()=>{
                                //         Vas.GetView("ErrorLogin",null,false)
                                //       }}/> 
                                //     , document.getElementById('messageContainer'));

                                break;
                            }
                            case 500:{
                                if(error.responseText !== null && error.responseText != undefined && error.responseText.indexOf("internal error") > -1){

                                    if(error.statusText !== null && error.statusText != undefined && error.statusText.indexOf("Description") > -1){
                                        let err = JSON.parse(error.statusText);

                                        ReactDOM.render(<MessageBox 
                                            AppURL={Vas.ApplicationUrl} 
                                            Title={Vas.Resources.Titles["Error"]} 
                                            Message={err.Description} /> 
                                            , document.getElementById('messageContainer'));
                                    }

                                    else if (error.responseText.indexOf("Account ist gesperrt")) {
                                        let errorMessage = "Account ist gesperrt";
                                        ReactDOM.render(<MessageBox 
                                        AppURL={Vas.ApplicationUrl} 
                                        Title={Vas.Resources.Titles["Error"]} 
                                        Message={Vas.Resources.Labels["AccountBlocked"] !== null && 
                                        Vas.Resources.Labels["AccountBlocked"] !== undefined 
                                            ? Vas.Resources.Labels["AccountBlocked"] 
                                            : errorMessage} /> 
                                            , document.getElementById('messageContainer'));
                                    }
                                } else {
                                    if (document.getElementById('LoadingIconPopUp') === null){
                                        ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
                                    }
                                    else {
                                        $("#LoadingIconPopUp").removeClass().addClass('hide');
                                    }
                                    if (error.responseJSON){
                                        switch (error.responseJSON.ErrorCode){
                                            case "7":
                                            case "1402":{//Dokument hängt an Nachweis
                                                ReactDOM.render(<MessageBox 
                                                AppURL={Vas.ApplicationUrl} 
                                                Title={Vas.Resources.Titles["Error"]} 
                                                Message={error.responseJSON.Description} /> 
                                                , document.getElementById('messageContainer'));
                                                break;
                                            }
                                            case "2":{// Expired Token
                                                if (localStorage.getItem('vas_token')){
                                                    Vas.clearLocalStorage();
                                                    //Hier Hinweis auf Token Expired in LoalStorage schreiben.
                                                    //Wenn Hinweis auf Token Expired in LoalStorage vorhanden, dann Hinweis entfernen und Messagebox anzeigen
                                                    //localStorage.setItem("ExpiredToken", "expiredToken");
                                    
                                                    Vas.GetView("ErrorLogin",null, false);                  
                                                } else {
                                                    Vas.clearLocalStorage();
                                                    Vas.GetView("ErrorOffline",null,false);
                                                }
                                                break;
                                            }
                                            case "1304":{// Fehler bei der Vertragsanlage, Kunde konnte nicht angelegt werden
                                                Vas.clearLocalStorage();
                                                if(error.responseJSON.Description){
                                                    localStorage.setItem('Error', error.responseJSON.Description);
                                                }
                                                Vas.GetView("ErrorOffline",null,false);
                                                break;
                                            }
                                            case "1600":{//Es gibt bereits eine zusätzliche Adresse mit dem gleichen von Datum
                                                ReactDOM.render(<MessageBox 
                                                    AppURL={Vas.ApplicationUrl} 
                                                    Title={Vas.Resources.Titles["Error"]} 
                                                    Message={error.responseJSON.Description} /> 
                                                    , document.getElementById('messageContainer'));
                                                    break;
                                            }
                                            case "17":{//Fehler bei der Bestandskundenregistriereung
                                                ReactDOM.render(<MessageBox 
                                                    AppURL={Vas.ApplicationUrl} 
                                                    Title={Vas.Resources.Titles["Error"]} 
                                                    Message={error.responseJSON.Description} /> 
                                                    , document.getElementById('messageContainer'));
                                                    break;
                                            }
                                            case "15":{//Account ist gesperrt
                                                ReactDOM.render(<MessageBox 
                                                    AppURL={Vas.ApplicationUrl} 
                                                    Title={Vas.Resources.Titles["Error"]} 
                                                    Message={Vas.Resources.Labels["AccountBlocked"] !== null && 
                                                            Vas.Resources.Labels["AccountBlocked"] !== undefined 
                                                                ? Vas.Resources.Labels["AccountBlocked"] 
                                                                : error.responseJSON.Description} /> 
                                                    , document.getElementById('messageContainer'));
                                                    break;
                                            }
                                            case "12":{//Account konnte nicht angelegt werden, da schon vorhanden
                                                ReactDOM.render(<MessageBox 
                                                AppURL={Vas.ApplicationUrl} 
                                                Title={Vas.Resources.Titles["Error"]} 
                                                Message={Vas.Resources.Labels["AccountCreationFailed"] !== null && 
                                                        Vas.Resources.Labels["AccountCreationFailed"] !== undefined 
                                                            ? Vas.Resources.Labels["AccountCreationFailed"] 
                                                            : error.responseJSON.Description} /> 
                                                , document.getElementById('messageContainer'));
                                                break;
                                            }
                                            default:{
                                                if (localStorage.getItem('vas_token')){
                                                    /*Vas.clearLocalStorage();
                                                    //Hier Hinweis auf Token Expired in LoalStorage schreiben.
                                                    //Wenn Hinweis auf Token Expired in LoalStorage vorhanden, dann Hinweis entfernen und Messagebox anzeigen
                                                    localStorage.setItem("ExpiredToken", "expiredToken");
                                    
                                                    Vas.GetView("Login",null, false);                  */
                                                    //localStorage.setItem('Error', error.responseJSON.Description);
                                                    Vas.GetView("ErrorOnline",null,true);
                                                } else {
                                                    Vas.clearLocalStorage();
                                                    //localStorage.setItem('Error', error.responseJSON.Description);
                                                    Vas.GetView("ErrorOffline",null,false);
                                                }
                                                break;
                                            }
                                        }
                                    } else {
                                        if (localStorage.getItem('vas_token')){
                                            Vas.clearLocalStorage();
                                            //Hier Hinweis auf Token Expired in LoalStorage schreiben.
                                            //Wenn Hinweis auf Token Expired in LoalStorage vorhanden, dann Hinweis entfernen und Messagebox anzeigen
                                            //localStorage.setItem("ExpiredToken", "expiredToken");
                            
                                            Vas.GetView("ErrorLogin",null, false);                  
                                        } else {
                                            Vas.clearLocalStorage();
                                            Vas.GetView("ErrorOffline",null,false);
                                        }
                                    }
                                }
                            
                                break;
                            }
                            default:{
                                if (error.responseJSON)
                                {
                                    if (error.responseJSON.info && error.responseJSON.info.message) {
                                        ReactDOM.render(<MessageBox 
                                        AppURL={Vas.ApplicationUrl} 
                                        Title={Vas.Resources.Titles["Error"]} 
                                        Message={error.responseJSON.info.message} /> 
                                            , document.getElementById('messageContainer'));
                                    }
                                } else

                                if (error.responseText) {
                                    ReactDOM.render(<MessageBox 
                                    AppURL={Vas.ApplicationUrl} 
                                    Title={Vas.Resources.Titles["Error"]} 
                                    Message={error.responseText} /> 
                                        , document.getElementById('messageContainer'));
                                }
                                break;
                            }
                        }
                    //}
                }
                else
                {
                    if (error.status !== 0)
                    {
                        ReactDOM.render(<MessageBox 
                        AppURL={Vas.ApplicationUrl} 
                        Title={Vas.Resources.Titles["Error"]} 
                        Message={error.responseText} /> 
                            , document.getElementById('messageContainer'));
                    }
                    else
                    {   
                        if(document.getElementById('messageContainer')){
                            ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
                        }
                        
                        ReactDOM.render(<MessageBox 
                        AppURL={Vas.ApplicationUrl} 
                        Title={Vas.Resources.Titles["Error"]} 
                        Message={Vas.Resources.ErrorMessages["ConnectionError"]} /> 
                            , document.getElementById('messageContainer'));
                    }
                }
            }
        }
        
    }
}
export default Vas;
